export {moveFooter};

const moveFooter = (ID_of_what: string, ID_to_where: string, ID_to_rename: string) => {
    const edcFooter = document.getElementById(ID_of_what);
    const sspFooter = document.getElementById(ID_to_where);

    if(edcFooter && sspFooter) {
        edcFooter.id = ID_to_rename;
        sspFooter.prepend(edcFooter);
    }
}